/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pills': {
    width: 16,
    height: 16,
    viewBox: '0 0 75.79 74',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M75.24 28v1.12a11.78 11.78 0 0 1-18 10l14.77-18a10.74 10.74 0 0 1 1.78 2.34m-10.2-6.15a11.19 11.19 0 0 1 6 1.75L55 36.92a11.34 11.34 0 0 1-3-7.78 11.73 11.73 0 0 1 11.69-11.76zM38.14 29.78l-3.45 4.44-18.16-14.13L28.3 4.93a11.7 11.7 0 0 1 16.24-2 11.4 11.4 0 0 1 1.92 16.16l-5.26 6.77M4.93 53.77A11.4 11.4 0 0 1 3 37.61l11.79-15.16L33 36.57 21.18 51.73a11.69 11.69 0 0 1-16.25 2.04zM26 61.66c0-6.21 8.66-11.51 19.41-12.16l.16 24C35.44 73 25.93 68.23 26 61.66zM53.36 72.8a34.09 34.09 0 0 1-4.73.51l-.16-24C59.36 49.69 68 54.95 68 61.16c0 4.48-4.14 8.4-10.32 10.52"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/pills.js